(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-events"]) return;
  try {
    
  loadScripts(['https://player.vimeo.com/api/player.js']);
  window.theme._.ready(function () {
    window.theme.videos.init('event__video');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faqs-apply"]) return;
  try {
    
  loadScripts(['https://player.vimeo.com/api/player.js']);
  window.theme._.ready(function () {
    window.theme.videos.init('instruction__video');
  });

  } catch(e) { console.error(e); }
})();
})();
